import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BoobleModalService } from 'booble-modal';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { ReconciliationSuccessModalComponent } from '../reconciliation-success-modal/reconciliation-success.modal.component';

@Component({
  selector: 'app-quotation-reconciliation-modal',
  templateUrl: './quotation-reconciliation-modal.component.html',
  styleUrls: ['./quotation-reconciliation-modal.component.scss']
})
export class QuotationReconciliationModalComponent implements OnInit {


  boobleModalData = new InboundOrderDto();
  orderForm: FormGroup;
  rType = '1';
  loading = false;
  panelOpenState = false;

  get orderFormControl() {
    return this.orderForm.controls;
  } 

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalService: BoobleModalService,
    private readonly orderService: OrdersService) {
    this.orderForm = fb.group({
      id: [],
      amountME: [null, Validators.required],
      amountMN: [null, Validators.required],
      vet: [null, Validators.required],
      rate: [null, Validators.required],
      tax: [null, Validators.required],
      iof: [null, Validators.required],
      aliquot: [null, Validators.required],
      effectiveAmount: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.boobleModalData.remmitanceType === 'INBOUND' ? this.rType = '0' : this.rType = '1';
    this.orderForm.patchValue(this.boobleModalData);
  }

  save() {
    this.orderService.sendConciliation(this.orderForm.value)
      .subscribe({
        next: () => this.modalService.present(ReconciliationSuccessModalComponent)
      });
  }

  goBack() {
    this.modalService.dismiss(null);
  }


}
